import * as React from "react";
import { Datagrid, ExportButton, List, TextField, TopToolbar } from "react-admin";
import { ExcelExport } from "../../../Helper/ExportExcel";

const CockpitAircraftDetail = props => {
  const ListActions = props => (
    <TopToolbar {...props}>
      <ExportButton {...props} maxResults={99999} />
    </TopToolbar>
  );

  const exporter = records => {
    const data = records.map(record => ({
      "AC Registration": record.acRegistration,
      Owner: record.owner,
      "AC MSN": record.acMsn,
      "AC Type": record.acType,
    }));

    const columns = Object.keys(data[0] || {}).map(record => ({ header: record }));

    ExcelExport(columns, data, "Aircraft Detail List");
  };

  return (
    <List
      {...props}
      filterDefaultValues={props.filterParams}
      actions={<ListActions />}
      exporter={exporter}
      bulkActionButtons={false}
    >
      <Datagrid>
        <TextField source="acRegistration" label="AC Registration" />
        <TextField source="owner" label="Owner" />
        <TextField source="acMsn" label="AC MSN" />
        <TextField source="acType" label="AC Type" />
      </Datagrid>
    </List>
  );
};

export default CockpitAircraftDetail;
